import { SpyneAppProperties, ViewStream } from "spyne";
import { UIMainView } from "components/ui/ui-main-view";
import { StageView } from "components/stage-view";
//import { spyneCMSContent } from "traits/utils/test-files";

export class AppView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "main";
    props.id = "app-main";
    localStorage.setItem('showTheLogin', true);
    const lsHideLoginVal = localStorage.getItem('showTheLogin');
    const hideLoginClass = String(lsHideLoginVal) === 'true' ? '' : 'hide-login';

    //props.class = `main ${hideLoginClass}`;

    props.class = 'main';

    //console.log("LOGIN IS ",{hideLoginClass, lsHideLoginVal}, props.class);
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onLoadTest() {
/*    const vs = new ViewStream({
      template: spyneCMSContent,
    });

    vs.appendToDom(document.querySelector("#spyne-plugin-json-cms"));*/
  }

  onRendered() {
    this.appendView(new StageView());
    this.appendView(new UIMainView());

    const config = SpyneAppProperties.getChannelConfig("ROUTE");
    //console.log('config is ',config);

    this.sendInfoToChannel(
      "CHANNEL_CODE_CONTAINER",
      { test: 5 },
      "CHANNEL_CODE_CONTAINER_TESTER_EVENT",
    );
  }
}
